// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  wreckId: __t.u64().primaryKey().name("wreck_id"),
  killId: __t.u64().name("kill_id"),
  victim: __t.identity(),
  victimName: __t.string().name("victim_name"),
  chassisKey: __t.string().name("chassis_key"),
  systemId: __t.string().name("system_id"),
  x: __t.f64(),
  y: __t.f64(),
  z: __t.f64(),
  createdAt: __t.timestamp().name("created_at"),
  expiresAt: __t.timestamp().name("expires_at"),
});
